export default {
  description: 'Logout from the current session',
  usage: ['client.logout() → Promise<Confirmation>'],
  example: {
    description: 'Logout',
    code: 'client.logout()'
  }
}



// WEBPACK FOOTER //
// ./src/data/api/backend_client/logout.js